import React from 'react'

export const ActionContext = React.createContext({} as any)
export const ActionCreationContext = React.createContext({} as any)
export const KPIContext = React.createContext({} as any)
export const KPICreationContext = React.createContext({} as any)
export const ObjectiveContext = React.createContext({} as any)
